/**
 * Default localized text (US English).
 */
export type Locale = Partial<typeof locale>

const locale = {
  danger: "Danger",
  default: "Info",
  success: "Success",
  warning: "Warning"
}

export default locale
